import { withStyles } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import { makeStyles } from "@material-ui/core/styles";

// Shared by the invoice view and all of its pieces.
export const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#f7f7f7",
    color: "#333",
    fontWeight: 600,
    fontSize: 13,
    padding: "13px 16px",
    borderBottom: "1px solid #ddd",
  },
  body: {
    fontSize: 13,
    padding: "13px 16px",
    color: "#444",
    borderBottom: "1px solid #eee",
  },
}))(TableCell);

export const useInvoiceStyles = makeStyles((theme) => ({
  root: { width: "100%" },

  sectionCard: {
    border: "1px solid #e5e5e5",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    overflow: "hidden",
  },

  cardHeader: {
    padding: theme.spacing(2, 2.5),
    backgroundColor: "#fafafa",
  },

  cardContent: { padding: theme.spacing(2.5) },

  sectionTitle: { fontSize: 15, fontWeight: 600, color: "#222" },

  sectionSubtitle: { fontSize: 12, color: "#888", marginTop: 3 },

  lotInput: {
    "& .MuiOutlinedInput-root": { backgroundColor: "#fff" },
    "& textarea": { lineHeight: 1.6, fontSize: 13 },
  },

  field: {
    "& .MuiInputBase-root": { backgroundColor: "#fff" },
    "& .MuiInputBase-input": { fontSize: 13 },
  },

  optionsBox: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    padding: "10px 14px",
    border: "1px solid #e2e2e2",
    borderRadius: 6,
    backgroundColor: "#fafafa",
  },

  optionLabel: {
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: 13,
      color: "#333",
      fontWeight: 500,
    },
    "& .MuiCheckbox-root": { padding: 6, marginRight: 4 },
  },

  optionDescription: {
    marginLeft: 34,
    marginTop: -2,
    fontSize: 11,
    color: "#888",
  },

  addonsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1.5),
  },

  addonRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  descriptionField: { flex: 2 },
  priceField: { flex: 1 },

  deleteButton: {
    color: "#777",
    "&:hover": {
      color: "#d32f2f",
      backgroundColor: "rgba(211,47,47,0.06)",
    },
  },

  addButton: { textTransform: "none", fontWeight: 600, fontSize: 12 },

  footer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(1.5, 2.5),
    backgroundColor: "#fafafa",
  },

  previewButton: {
    minWidth: 130,
    height: 38,
    borderRadius: 6,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",
    "&:hover": { boxShadow: "none" },
  },

  tableCard: {
    border: "1px solid #e5e5e5",
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
  },

  // NOTE: tableTitle and tableSubtitle were each declared twice in the
  // original useStyles. The later pair silently overwrote the earlier one.
  // Only the winning pair is kept.
  tableTitle: { fontWeight: 700, fontSize: "1.1rem", color: "#1f2937" },

  tableSubtitle: { marginTop: 4, color: "#6b7280", fontSize: "0.85rem" },

  table: { minWidth: 650 },
  tableContainer: { maxHeight: 600 },
  tableRow: { "&:hover": { backgroundColor: "#fafafa" } },

  clientName: { fontWeight: 500, color: "#222" },
  email: { color: "#666" },

  emptyState: { padding: theme.spacing(5), color: "#999", fontSize: 13 },

  actionButton: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 12,
    minWidth: 78,
    borderRadius: 5,
    boxShadow: "none",
  },

  backdrop: { zIndex: theme.zIndex.drawer + 1, color: "#fff" },

  modeBar: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },

  modeButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 6,
    boxShadow: "none",
  },

  bulkWrapper: { width: "100%" },
}));

// One place for money formatting. It was written out inline eight times
// in the original file, with the same options repeated each time.
export const formatMoney = (value) =>
  Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
